import "./ServiceData.scss";

import React, { useState } from 'react';
import { ServiceDataProps, ServiceProps } from "./ServiceDataTypes";
import { postApiCreateService, putApiUpdateService } from "../../../services/apiService";
import InputText from "../../InputText/InputText";
import Button from "../../Button/Button";
import {
  BtnBold,
  BtnBulletList,
  BtnItalic,
  BtnUnderline,
  Editor,
  EditorProvider,
  Toolbar
} from 'react-simple-wysiwyg';
import { useNavigate } from "react-router-dom";

const ServiceData = (ServiceDataProps: ServiceDataProps): React.ReactElement => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState<boolean>(false);
  const [service, setService] = useState<ServiceProps>(ServiceDataProps.service);
  const [formErrors, setFormErrors] = useState<any>({});

  const saveServiceData = async (): Promise<void> => {
    setSaving(true);
    let error = false;
    setFormErrors({});

    if (!service.title) {
      setFormErrors((prev: any) => ({ ...prev, title: "El título es obligatorio" }));
      error = true;
    }
    if (!service.description) {
      setFormErrors((prev: any) => ({ ...prev, description: "La descripción es obligatoria" }));
      error = true;
    }
    if (!service.obtain) {
      setFormErrors((prev: any) => ({ ...prev, obtain: "El campo '¿Qué obtendrás?' es obligatorio" }));
      error = true;
    }

    if (error) {
      setFormErrors((prev: any) => ({ ...prev, form: "Hay errores en el formulario" }));
      setSaving(false);
      return;
    }

    const attributes: any = {
      service: {
        title: service.title,
        price: service.price,
        description: service.description,
        obtain: service.obtain
      }
    };

    try {
      if (service._id && service._id !== '') {
        attributes.service._id = service._id;
        await putApiUpdateService(attributes);
      } else {
        await postApiCreateService(attributes);
      }
      setSaving(false);
      navigate('/servicios');
    } catch (err: any) {
      setSaving(false);
      console.log(err.message);
    }
  };

  return (
    <React.Fragment>
      <div className="row mb-5">
        <div className="col-md-8 my-3">
          <InputText
            label="Título *"
            placeholder="Nombre del servicio"
            value={service.title}
            onChange={(event: any) => setService({ ...service, title: event.currentTarget.value })} />
          {formErrors.title && <p className="error">{formErrors.title}</p>}
        </div>

        <div className="col-md-4 my-3">
          <InputText
            label="Precio"
            placeholder="10,50"
            value={service.price ? service.price : ''}
            onChange={(event: any) => setService({ ...service, price: event.currentTarget.value })} />
        </div>

        {service._id && service._id !== '' &&
          <div className="col-md-12 my-3">
            <InputText
              label="Slug"
              placeholder="slug-del-servicio"
              value={service.slug ? service.slug : ''}
              readonly={true}
              onChange={(event: any) => setService({ ...service, slug: event.currentTarget.value })} />
            <small className="text-muted">URL: /servicio/{service.slug}</small>
          </div>
        }

        <div className="col-12 my-3">
          <label className="mb-2">Descripción *</label>
          <EditorProvider>
            <Editor
              value={service.description ? service.description.replaceAll('&lt;', '<') : ''}
              onChange={(event: any) => setService({ ...service, description: event.target.value })}>
              <Toolbar>
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <BtnBulletList />
              </Toolbar>
            </Editor>
          </EditorProvider>
          {formErrors.description && <p className="error">{formErrors.description}</p>}
        </div>

        <div className="col-12 my-3">
          <label className="mb-2">¿Qué obtendrás? *</label>
          <EditorProvider>
            <Editor
              value={service.obtain ? service.obtain.replaceAll('&lt;', '<') : ''}
              onChange={(event: any) => setService({ ...service, obtain: event.target.value })}>
              <Toolbar>
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <BtnBulletList />
              </Toolbar>
            </Editor>
          </EditorProvider>
          {formErrors.obtain && <p className="error">{formErrors.obtain}</p>}
        </div>
      </div>

      <div className="row pb-5">
        <div className="col text-center">
          {formErrors.form && <p className="error">{formErrors.form}</p>}
          <Button value="Guardar" className="btn-orange mx-auto" onClick={saveServiceData} iconRight={saving ? 'loaderIcon' : ''} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ServiceData;
